import React from 'react'

const Callbtn = () => {
  return (
 <button className="call-btn" onClick={() => window.location.href = "tel:+91 81780 67868"}>
GET A CALL BACK
</button>
   
  )
}

export default Callbtn
